module.exports = __webpack_public_path__ + "media/images/delete-31d5f89ebf847cc14770ab99670cd1bc.png";